import styled from "styled-components";
export const VisibleSearcherWrapper = styled.div.withConfig({
    displayName: "styled__VisibleSearcherWrapper",
    componentId: "sc-7ed51b42-0"
})`
	width: 100%;
	height: 100%;

	transition: opacity 0.3s;
	${({ $isActive  })=>$isActive ? `
        opacity: 1;
    ` : `
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        pointer-events: none;
    `}
`;

//# sourceMappingURL=styled.js.map